// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bjYU","colMin":"styles_colMin__XY3lw"};